module.exports = __webpack_public_path__ + "static/media/3.8569cd95.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/trolls-girl/shirt/3.png
// module id = 63
// module chunks = 0